"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _ComponentWithBodyClass = _interopRequireDefault(require("../utils/ComponentWithBodyClass"));

/**
 * Standard page container, setting classes, context, etc.
 */
var _default = _react.default.createClass({
  displayName: "UIPage",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: (0, _extends2.default)({}, _ComponentWithBodyClass.default.propTypes, {
    bodyClassName: _react.PropTypes.string,
    children: _react.PropTypes.node.isRequired,
    tagName: _react.PropTypes.string.isRequired
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _ComponentWithBodyClass.default.defaultProps, {
      tagName: 'div'
    });
  },
  render: function render() {
    var _this$props = this.props,
        bodyClassName = _this$props.bodyClassName,
        bodyElement = _this$props.bodyElement,
        children = _this$props.children,
        className = _this$props.className,
        TagName = _this$props.tagName,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["bodyClassName", "bodyElement", "children", "className", "tagName"]);
    var classes = (0, _classNames.default)(className, 'private-page');
    var bodyClasses = (0, _classNames.default)(bodyClassName);

    var renderedChildren = _react.default.createElement(TagName, (0, _extends2.default)({}, rest, {
      className: classes
    }), children);

    if (bodyClassName) {
      return _react.default.createElement(_ComponentWithBodyClass.default, {
        bodyClassName: bodyClasses,
        bodyElement: bodyElement
      }, renderedChildren);
    }

    return renderedChildren;
  }
});

exports.default = _default;
module.exports = exports.default;